import { SorterResult, TablePaginationConfig } from 'antd/es/table/interface'
import { useAppSearchParams } from 'shared/libs/hooks/useAppSearchParams'
import { paginationDefault } from 'shared/model/paginationDefault'
import { ColumnTypeTable } from 'shared/types/Common'

export const useOrderingTable = () => {
  const { setParam } = useAppSearchParams()
  const { page, limit } = paginationDefault

  const handleSorterParam = ({
    order,
    field,
    column,
  }: SorterResult<any>): string | null => {
    const sortField = (column as ColumnTypeTable<any>)?.sortField || field
    if (order) return order === 'ascend' ? `-${sortField}` : `${sortField}`
    else return null
  }

  const addCommonParmas = (
    pagination: TablePaginationConfig,
    sorter: SorterResult<any> | SorterResult<any>[],
  ) => {
    if (Array.isArray(sorter)) {
      const sorterValues = sorter
        .map(handleSorterParam)
        .filter(Boolean) as string[]
      setParam('ordering', sorterValues.join(','))
    } else {
      const sortedValue = handleSorterParam(sorter)
      setParam('ordering', sortedValue ?? '')
    }

    setParam('page', pagination.current?.toString() || page.toString())
    setParam('limit', pagination.pageSize?.toString() || limit.toString())
  }

  return {
    addCommonParmas,
  }
}
